import { GenericAction, GenericActionWithPayload } from "./action-types";

type LoginUserDoneAction = GenericActionWithPayload<
  "LOGIN_USER_DONE",
  { rememberToken: string | null }
>;

type RegisterUserDoneAction = GenericActionWithPayload<
  "REGISTER_USER_DONE",
  { rememberToken: string | null }
>;

type ClearRegisterUserTokenAction = GenericAction<"CLEAR_REGISTER_USER_TOKEN">;

type InvalidateSessionAction = GenericAction<"INVALIDATE_SESSION">;

type SignoutAction = GenericAction<"SIGNOUT">;

type CookieAction =
  | RegisterUserDoneAction
  | LoginUserDoneAction
  | ClearRegisterUserTokenAction
  | InvalidateSessionAction
  | SignoutAction;

export {
  CookieAction,
  LoginUserDoneAction,
  RegisterUserDoneAction,
  ClearRegisterUserTokenAction,
  InvalidateSessionAction,
  SignoutAction,
};
